<template>
    <Transition name="fade">
      <div
        v-if="isOpen"
        class="fixed inset-0 flex items-center justify-center backdrop-blur-md bg-black/30 z-50"
        @click.self="$emit('close')"
      >
        <div
          class="flex flex-col items-center justify-center bg-white rounded-lg shadow-lg p-4 gap-0 w-full max-w-xl mx-4"
          :class="customClass"
        >
          <h2 class="text-xl font-semibold text-gray-800 text-center pb-4">
            Cambiar cuenta
          </h2>
  
          <div class="relative w-full">
            <inputPrimary
              v-model="searchText"
              :label="$t('property.form.fields.searchAccount')"
              :placeholder="$t('property.form.fields.searchPlaceholder')"
            />
            <div
              v-if="searchResults && searchResults.length > 0"
              class="border rounded mt-2 p-2 absolute bg-white z-10 w-full"
            >
              <ul>
                <li
                  v-for="item in searchResults"
                  :key="item.id"
                  class="hover:bg-gray-100 cursor-pointer px-2 py-1"
                  @click="selectSearchResult(item)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div v-else-if="searchText && searchResults && searchResults.length === 0">
              <p>{{ $t('property.form.fields.noResults') }}</p>
            </div>
          </div>
  
          <div class="mt-4 flex gap-2 pt-6 px-6">
            <ButtonWhite @click="confirmChange" :disabled="!selectedAccount">
              Confirmar
            </ButtonWhite>
            <ButtonWhite @click="close">Cancelar</ButtonWhite>
          </div>
          <div v-if="error" class="text-red-500">{{ error }}</div>
        </div>
      </div>
    </Transition>
  </template>
  
  <script setup>
  import { ref, watch } from 'vue'
  import axios from 'axios'
  import ButtonWhite from '../button/ButtonWhite.vue'
  import inputPrimary from '../inputs/input-primary.vue'
  
  const props = defineProps({
    isOpen: Boolean,
    propertyId: [String, Number],
  })
  const emit = defineEmits(['close', 'account-changed'])
  
  const searchText = ref('')
  const searchResults = ref([])
  const selectedAccount = ref(null)
  const error = ref(null)
  
  // Buscar cuentas cada vez que cambia el texto
  watch(searchText, async (newText) => {
    if (newText && newText.length >= 2) {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/user/superadmin/admins/search`,
          {
            headers: {
              'Accept': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            params: {
              query: newText,
              per_page: 10,
              search_by: 'name',
            },
          }
        )
        // Ajusta según la estructura real de tu API
        searchResults.value = response.data.value?.data || []
      } catch (e) {
        error.value = 'Error buscando cuentas'
        searchResults.value = []
      }
    } else {
      searchResults.value = []
    }
  })
  
  function selectSearchResult(item) {
    selectedAccount.value = item
    searchText.value = item.name
    searchResults.value = []
  }
  
  async function confirmChange() {
    if (!selectedAccount.value) return
    try {
      await axios.put(
        `${import.meta.env.VITE_API_URL}/property/update/${props.propertyId}`,
        {
          propietario_id: selectedAccount.value.id,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      )
      emit('account-changed')
      close()
    } catch (e) {
      error.value = 'Error cambiando la cuenta'
    }
  }
  
  function close() {
    searchText.value = ''
    searchResults.value = []
    selectedAccount.value = null
    error.value = null
    emit('close')
  }
  </script>
  

<style scoped>
.selected {
  background: #e0e0e0;
}
</style>